/* eslint-disable max-lines */
export interface Province {
  nome: string;
  sigla: string;
  regione: string;
}

export const provinces: Province[] = [
  {
    nome: 'AGRIGENTO',
    sigla: 'AG',
    regione: 'Sicilia',
  },
  {
    nome: 'ALESSANDRIA',
    sigla: 'AL',
    regione: 'Piemonte',
  },
  {
    nome: 'ANCONA',
    sigla: 'AN',
    regione: 'Marche',
  },
  {
    nome: 'AOSTA',
    sigla: 'AO',
    regione: "Valle d'Aosta/Vallée d'Aoste",
  },
  {
    nome: 'AREZZO',
    sigla: 'AR',
    regione: 'Toscana',
  },
  {
    nome: 'ASCOLI PICENO',
    sigla: 'AP',
    regione: 'Marche',
  },
  {
    nome: 'ASTI',
    sigla: 'AT',
    regione: 'Piemonte',
  },
  {
    nome: 'AVELLINO',
    sigla: 'AV',
    regione: 'Campania',
  },
  {
    nome: 'BARI',
    sigla: 'BA',
    regione: 'Puglia',
  },
  {
    nome: 'BARLETTA-ANDRIA-TRANI',
    sigla: 'BT',
    regione: 'Puglia',
  },
  {
    nome: 'BELLUNO',
    sigla: 'BL',
    regione: 'Veneto',
  },
  {
    nome: 'BENEVENTO',
    sigla: 'BN',
    regione: 'Campania',
  },
  {
    nome: 'BERGAMO',
    sigla: 'BG',
    regione: 'Lombardia',
  },
  {
    nome: 'BIELLA',
    sigla: 'BI',
    regione: 'Piemonte',
  },
  {
    nome: 'BOLOGNA',
    sigla: 'BO',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'BOLZANO',
    sigla: 'BZ',
    regione: 'Trentino-Alto Adige/Südtirol',
  },
  {
    nome: 'BRESCIA',
    sigla: 'BS',
    regione: 'Lombardia',
  },
  {
    nome: 'BRINDISI',
    sigla: 'BR',
    regione: 'Puglia',
  },
  {
    nome: 'CAGLIARI',
    sigla: 'CA',
    regione: 'Sardegna',
  },
  {
    nome: 'CALTANISSETTA',
    sigla: 'CL',
    regione: 'Sicilia',
  },
  {
    nome: 'CAMPOBASSO',
    sigla: 'CB',
    regione: 'Molise',
  },
  {
    nome: 'CARBONIA-IGLESIAS',
    sigla: 'CI',
    regione: 'Sardegna',
  },
  {
    nome: 'CASERTA',
    sigla: 'CE',
    regione: 'Campania',
  },
  {
    nome: 'CATANIA',
    sigla: 'CT',
    regione: 'Sicilia',
  },
  {
    nome: 'CATANZARO',
    sigla: 'CZ',
    regione: 'Calabria',
  },
  {
    nome: 'CHIETI',
    sigla: 'CH',
    regione: 'Abruzzo',
  },
  {
    nome: 'COMO',
    sigla: 'CO',
    regione: 'Lombardia',
  },
  {
    nome: 'COSENZA',
    sigla: 'CS',
    regione: 'Calabria',
  },
  {
    nome: 'CREMONA',
    sigla: 'CR',
    regione: 'Lombardia',
  },
  {
    nome: 'CROTONE',
    sigla: 'KR',
    regione: 'Calabria',
  },
  {
    nome: 'CUNEO',
    sigla: 'CN',
    regione: 'Piemonte',
  },
  {
    nome: 'ENNA',
    sigla: 'EN',
    regione: 'Sicilia',
  },
  {
    nome: 'FERMO',
    sigla: 'FM',
    regione: 'Marche',
  },
  {
    nome: 'FERRARA',
    sigla: 'FE',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'FIRENZE',
    sigla: 'FI',
    regione: 'Toscana',
  },
  {
    nome: 'FOGGIA',
    sigla: 'FG',
    regione: 'Puglia',
  },
  {
    nome: "FORLI'-CESENA",
    sigla: 'FC',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'FROSINONE',
    sigla: 'FR',
    regione: 'Lazio',
  },
  {
    nome: 'GENOVA',
    sigla: 'GE',
    regione: 'Liguria',
  },
  {
    nome: 'GORIZIA',
    sigla: 'GO',
    regione: 'Friuli-Venezia Giulia',
  },
  {
    nome: 'GROSSETO',
    sigla: 'GR',
    regione: 'Toscana',
  },
  {
    nome: 'IMPERIA',
    sigla: 'IM',
    regione: 'Liguria',
  },
  {
    nome: 'ISERNIA',
    sigla: 'IS',
    regione: 'Molise',
  },
  {
    nome: "L'AQUILA",
    sigla: 'AQ',
    regione: 'Abruzzo',
  },
  {
    nome: 'LA SPEZIA',
    sigla: 'SP',
    regione: 'Liguria',
  },
  {
    nome: 'LATINA',
    sigla: 'LT',
    regione: 'Lazio',
  },
  {
    nome: 'LECCE',
    sigla: 'LE',
    regione: 'Puglia',
  },
  {
    nome: 'LECCO',
    sigla: 'LC',
    regione: 'Lombardia',
  },
  {
    nome: 'LIVORNO',
    sigla: 'LI',
    regione: 'Toscana',
  },
  {
    nome: 'LODI',
    sigla: 'LO',
    regione: 'Lombardia',
  },
  {
    nome: 'LUCCA',
    sigla: 'LU',
    regione: 'Toscana',
  },
  {
    nome: 'MACERATA',
    sigla: 'MC',
    regione: 'Marche',
  },
  {
    nome: 'MANTOVA',
    sigla: 'MN',
    regione: 'Lombardia',
  },
  {
    nome: 'MASSA-CARRARA',
    sigla: 'MS',
    regione: 'Toscana',
  },
  {
    nome: 'MATERA',
    sigla: 'MT',
    regione: 'Basilicata',
  },
  {
    nome: 'Medio Campidano',
    sigla: 'VS',
    regione: 'Sardegna',
  },
  {
    nome: 'MESSINA',
    sigla: 'ME',
    regione: 'Sicilia',
  },
  {
    nome: 'MILANO',
    sigla: 'MI',
    regione: 'Lombardia',
  },
  {
    nome: 'MODENA',
    sigla: 'MO',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'MONZA E DELLA BRIANZA',
    sigla: 'MB',
    regione: 'Lombardia',
  },
  {
    nome: 'NAPOLI',
    sigla: 'NA',
    regione: 'Campania',
  },
  {
    nome: 'NOVARA',
    sigla: 'NO',
    regione: 'Piemonte',
  },
  {
    nome: 'NUORO',
    sigla: 'NU',
    regione: 'Sardegna',
  },
  {
    nome: 'OGLIASTRA',
    sigla: 'OG',
    regione: 'Sardegna',
  },
  {
    nome: 'OLBIA-TEMPIO',
    sigla: 'OT',
    regione: 'Sardegna',
  },
  {
    nome: 'ORISTANO',
    sigla: 'OR',
    regione: 'Sardegna',
  },
  {
    nome: 'PADOVA',
    sigla: 'PD',
    regione: 'Veneto',
  },
  {
    nome: 'PALERMO',
    sigla: 'PA',
    regione: 'Sicilia',
  },
  {
    nome: 'PARMA',
    sigla: 'PR',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'PAVIA',
    sigla: 'PV',
    regione: 'Lombardia',
  },
  {
    nome: 'PERUGIA',
    sigla: 'PG',
    regione: 'Umbria',
  },
  {
    nome: 'PESARO E URBINO',
    sigla: 'PU',
    regione: 'Marche',
  },
  {
    nome: 'PESCARA',
    sigla: 'PE',
    regione: 'Abruzzo',
  },
  {
    nome: 'PIACENZA',
    sigla: 'PC',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'PISA',
    sigla: 'PI',
    regione: 'Toscana',
  },
  {
    nome: 'PISTOIA',
    sigla: 'PT',
    regione: 'Toscana',
  },
  {
    nome: 'PORDENONE',
    sigla: 'PN',
    regione: 'Friuli-Venezia Giulia',
  },
  {
    nome: 'POTENZA',
    sigla: 'PZ',
    regione: 'Basilicata',
  },
  {
    nome: 'PRATO',
    sigla: 'PO',
    regione: 'Toscana',
  },
  {
    nome: 'RAGUSA',
    sigla: 'RG',
    regione: 'Sicilia',
  },
  {
    nome: 'RAVENNA',
    sigla: 'RA',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'REGGIO CALABRIA',
    sigla: 'RC',
    regione: 'Calabria',
  },
  {
    nome: 'REGGIO EMILIA',
    sigla: 'RE',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'RIETI',
    sigla: 'RI',
    regione: 'Lazio',
  },
  {
    nome: 'RIMINI',
    sigla: 'RN',
    regione: 'Emilia-Romagna',
  },
  {
    nome: 'ROMA',
    sigla: 'RM',
    regione: 'Lazio',
  },
  {
    nome: 'ROVIGO',
    sigla: 'RO',
    regione: 'Veneto',
  },
  {
    nome: 'SALERNO',
    sigla: 'SA',
    regione: 'Campania',
  },
  {
    nome: 'SASSARI',
    sigla: 'SS',
    regione: 'Sardegna',
  },
  {
    nome: 'SAVONA',
    sigla: 'SV',
    regione: 'Liguria',
  },
  {
    nome: 'SIENA',
    sigla: 'SI',
    regione: 'Toscana',
  },
  {
    nome: 'SIRACUSA',
    sigla: 'SR',
    regione: 'Sicilia',
  },
  {
    nome: 'SONDRIO',
    sigla: 'SO',
    regione: 'Lombardia',
  },
  {
    nome: 'SUD SARDEGNA',
    sigla: 'SU',
    regione: 'Sardegna',
  },
  {
    nome: 'TARANTO',
    sigla: 'TA',
    regione: 'Puglia',
  },
  {
    nome: 'TERAMO',
    sigla: 'TE',
    regione: 'Abruzzo',
  },
  {
    nome: 'TERNI',
    sigla: 'TR',
    regione: 'Umbria',
  },
  {
    nome: 'TORINO',
    sigla: 'TO',
    regione: 'Piemonte',
  },
  {
    nome: 'TRAPANI',
    sigla: 'TP',
    regione: 'Sicilia',
  },
  {
    nome: 'TRENTO',
    sigla: 'TN',
    regione: 'Trentino-Alto Adige/Südtirol',
  },
  {
    nome: 'TREVISO',
    sigla: 'TV',
    regione: 'Veneto',
  },
  {
    nome: 'TRIESTE',
    sigla: 'TS',
    regione: 'Friuli-Venezia Giulia',
  },
  {
    nome: 'UDINE',
    sigla: 'UD',
    regione: 'Friuli-Venezia Giulia',
  },
  {
    nome: 'VARESE',
    sigla: 'VA',
    regione: 'Lombardia',
  },
  {
    nome: 'VENEZIA',
    sigla: 'VE',
    regione: 'Veneto',
  },
  {
    nome: 'VERBANO CUSIO OSSOLA',
    sigla: 'VB',
    regione: 'Piemonte',
  },
  {
    nome: 'VERCELLI',
    sigla: 'VC',
    regione: 'Piemonte',
  },
  {
    nome: 'VERONA',
    sigla: 'VR',
    regione: 'Veneto',
  },
  {
    nome: 'VIBO VALENTIA',
    sigla: 'VV',
    regione: 'Calabria',
  },
  {
    nome: 'VICENZA',
    sigla: 'VI',
    regione: 'Veneto',
  },
  {
    nome: 'VITERBO',
    sigla: 'VT',
    regione: 'Lazio',
  },
];
